export default __webpack_public_path__ + "images/02b65eb53d32a0836aa02696346528d2-cc-mini-front.png";